import { View, ClockView, ProgressView, TextView } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";
import { ChunkIndicatorView } from "./ChunkIndicatorView";

export class CallToActionView extends View {
    /**
     * Displays a countdown that represents the time to the next betstop.
     */
    clockView: ClockView;
    clockOptions:any;
    /**
     * Displays a progress bar that represents the time to the next betstop.
     */
    progressView: ProgressView;
    /**
     * Displays a lock.
     */
    lockView: View;
    /**
     * Displays 'Place your bets' or 'Betstop' in the appropriate language.
     */
    textView: TextView;
    /**
     * displays competition id and chunk identification
     */
    chunkIndicatorView: ChunkIndicatorView;
    /**
     * the selected chunk
     */
    chunk: Chunk;

    programCodeNameView: TextView;
    programCodeValueView: TextView;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'callToActionView';
        options.selector = options.selector || '#calltoactionView';
        super( options );

        this.clockOptions = options.clock || {};
        this.progressView = options.progressView;
        this.lockView = options.lockView;
        this.textView = options.textView;
        this.chunkIndicatorView = options.chunkIndicatorView;
        this.programCodeNameView = options.programCodeNameView;
        this.programCodeValueView = options.programCodeValueView;

        this.chunk = null;
    }

    handleDomInstantiated() {
        this.chunkIndicatorView = this.chunkIndicatorView ? this.addSubView( this.chunkIndicatorView, null, false ) : null;
        this.clockView = this.addSubView( new ClockView( {
            name: this.clockOptions.name || 'clock',
            selector: this.clockOptions.selector || this.selector+' #clock',
            clockLayout: this.clockOptions.layout || null,
            hourLayout: this.clockOptions.hourLayout || null
        } ) );
        this.progressView = this.progressView ? this.addSubView( this.progressView ) : null;
        this.lockView = this.lockView ? this.addSubView( this.lockView ) : null;
        this.textView = this.textView ? this.addSubView( this.textView ) : null;
        this.programCodeNameView = this.programCodeNameView? this.addSubView( this.programCodeNameView) : null;
        this.programCodeValueView = this.programCodeValueView? this.addSubView( this.programCodeValueView) : null;
        super.handleDomInstantiated();
    }

    setPosition( seconds_left ) {
        //console.log( 'countdownView.setPosition', seconds_left );
        $(this.selector).removeClass('counter_stopped');

        // show e.g. odds header elements
        $('body').removeClass('call_to_action_counter_stopped');

        this.progressView.$domNode.removeClass('inactive');
        this.clockView.$domNode.removeClass('inactive');

        // TODO are these calls necessary here?
        if( seconds_left > 0 ) {
            if( this.lockView.isShown ) {
                this.lockView.hide();
            }
        }
        this.clockView.stop();
        this.clockView.setPosition( seconds_left );
        this.clockView.start();
        this.clockView.show();
    }

    clearCountdown() {
        //console.log( 'countdownView.clearCountdown' );
        this.$domNode.addClass('counter_stopped');
        this.stop();

        // hide e.g. odds header elements
        $('body').addClass('call_to_action_counter_stopped');

        this.progressView.$domNode.addClass('inactive');
        this.textView.$domNode.css('color', '');
    }

    stop() {
        //console.log( 'countdownView.stop' );
        this.clockView.stop();
        // we also need to clear(hide) the clockView
        this.clockView.clear();
        this.clockView.hide();
        this.lockView.show();
    }

    disable(){
        this.clockView.stop();
        if( this.progressView ) { this.progressView.disable(); }
        if( this.clockView ) { this.clockView.disable(); }
        if( this.textView ) { this.textView.disable(); }
        if( this.chunkIndicatorView ) { this.chunkIndicatorView.disable(); }
        super.disable();
    }

    setChunk( chunk: Chunk ) {
        this.chunk = chunk;
        this.refresh();
    }
}